import { TrendingUp, TrendingDown, Minus } from 'lucide-react';
import { cn, formatCurrency, formatNumber } from '@/lib/utils';

interface StatCardProps {
  title: string;
  value: number;
  format?: 'currency' | 'number' | 'percent';
  currency?: string;
  change?: number;
  icon?: React.ReactNode;
}

export function StatCard({ title, value, format = 'number', currency = 'USD', change, icon }: StatCardProps) {
  const formattedValue =
    format === 'currency'
      ? formatCurrency(value, currency)
      : format === 'percent'
        ? `${value.toFixed(1)}%`
        : formatNumber(value);

  return (
    <div className="border border-border bg-card p-4 space-y-2">
      <div className="flex items-center justify-between">
        <span className="text-sm text-muted-foreground">{title}</span>
        {icon && <span className="text-muted-foreground">{icon}</span>}
      </div>
      <div className="text-2xl font-bold">{formattedValue}</div>
      {change !== undefined && (
        <div className={cn('flex items-center gap-1 text-xs',
          change > 0 ? 'text-green-600' : change < 0 ? 'text-red-600' : 'text-muted-foreground'
        )}>
          {change > 0 ? <TrendingUp className="h-3 w-3" /> : change < 0 ? <TrendingDown className="h-3 w-3" /> : <Minus className="h-3 w-3" />}
          {change > 0 ? '+' : ''}{change.toFixed(1)}% vs prev period
        </div>
      )}
    </div>
  );
}
